import React from 'react'
import { Label, Header, Segment, Grid, GridColumn, GridRow, Container, Button } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundUrlAnswGood from '../assets/000003.mp3'
import soundUrlAnswBad from '../assets/000004.mp3'

const colorRight = 'green';
const colorFalse = 'teal';
const colorBase = 'blue'

class FormAnswer extends React.Component {
   
    constructor(props) {
        super(props)
        this.state = {
            answer: '',
            starting_time: null,
            msToAnswer: props.msToAnswer,
            jump:props.jump,
            question:props.question,
            isRunning:true,
            colorA: colorBase,
            colorB:colorBase,
            colorC:colorBase,
            colorD:colorBase,
            sound:false,
            soundWrong1:false,
            soundWrong2:false,
            soundWrong3:false,
            numberOfMistakes:0,
        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
        this.focusTextInput();
    }

    onAnswerChange = (e) => this.setState({ answer: e.target.value })

    onSubmit = (e) => {
        e.preventDefault()
        return false
    }

    
    onTimerFinished = () => {
        switch(this.state.question.answer){
            case 'A':
                this.setState({colorA:colorRight,
                               colorB:colorFalse,
                               colorC:colorFalse,
                               colorD:colorFalse
                });
                break;
            case 'B':
                this.setState({colorA:colorFalse,
                    colorB:colorRight,
                    colorC:colorFalse,
                    colorD:colorFalse
                });
                break;
            case 'C':
                this.setState({colorA:colorFalse,
                    colorB:colorFalse,
                    colorC:colorRight,
                    colorD:colorFalse
                });
                break;
            case 'D':
                this.setState({colorA:colorFalse,
                    colorB:colorFalse,
                    colorC:colorFalse,
                    colorD:colorRight
                });
                break;
            default:
                break;
        }
        this.setState({isRunning:false});
    }

    handleInput = (e)  =>{
        if (this.state.isRunning){
            if (e.target.value == this.state.question.answer){
                this.setState({msToAnswer:this.state.msToAnswer})
                this.setState({isRunning:false})
                this.setState({sound:true})
                switch(e.target.value){
                    case 'A':
                        this.setState({colorA:colorRight,
                                       colorB:colorFalse,
                                       colorC:colorFalse,
                                       colorD:colorFalse
                        });
                        break;
                    case 'B':
                        this.setState({colorA:colorFalse,
                            colorB:colorRight,
                            colorC:colorFalse,
                            colorD:colorFalse
                        });
                        break;
                    case 'C':
                        this.setState({colorA:colorFalse,
                            colorB:colorFalse,
                            colorC:colorRight,
                            colorD:colorFalse
                        });
                        break;
                    case 'D':
                        this.setState({colorA:colorFalse,
                            colorB:colorFalse,
                            colorC:colorFalse,
                            colorD:colorRight
                        });
                        break;
                    default:
                        break;
                }
            } else{
                this.setState({msToAnswer:this.state.msToAnswer-this.state.jump})
                let numbMist = this.state.numberOfMistakes;
                switch(this.state.numberOfMistakes){
                    case 0:
                        this.setState({soundWrong1:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 1:
                        this.setState({soundWrong2:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 2:
                        this.setState({soundWrong3:true, numberOfMistakes:numbMist+1 })
                        break;
                    default:
                        break;
                }
                switch(e.target.value){
                    case 'A':
                        this.setState({colorA:colorFalse});
                        break;
                    case 'B':
                        this.setState({colorB:colorFalse});
                        break;
                    case 'C':
                        this.setState({colorC:colorFalse});
                        break;
                    case 'D':
                        this.setState({colorD:colorFalse});
                        break;
                    default:
                        break;
                }
            }
        }
    }

    render() {
        const {msToAnswer,colorA,colorB,colorC,colorD,question, sound, soundWrong1,soundWrong2,soundWrong3, isRunning} = this.state
        const { text, opzioneA, opzioneB, opzioneC, opzioneD } = question
        if (!isRunning) setTimeout(this.props.onGameEnded,2000);
        return (
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"Domanda"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>{text}</Header>
                        {sound?<audio ref="audio_tag" src={soundUrlAnswGood} autoPlay/>:""}
                        {soundWrong1?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong2?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong3?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        <Grid centered celled>
                            <GridRow >
                               <GridColumn centered width={8}>
                               <Container textAlign='center'>
                               <Button fluid  color={colorA} value='A' onClick={this.handleInput}>
                                    {opzioneA}
                                </Button>
                                </Container>

                               </GridColumn>
                               <GridColumn centered width={8}>
                               <Button fluid  color={colorB} value='B' onClick={this.handleInput}>
                                   {opzioneB}
                                </Button>
                                </GridColumn>
                            </GridRow>
                            <GridRow >
                               <GridColumn centered  width={8}>
                               <Button fluid  color={colorC} value='C' onClick={this.handleInput}>
                                   {opzioneC}
                               </Button>
                               </GridColumn>
                               <GridColumn centered width={8}>
                               <Button fluid  color={colorD} value='D' onClick={this.handleInput}>
                                   {opzioneD}
                                </Button>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                        <Timer  ms={msToAnswer} bar={false} isReady={true} isRunning={this.state.isRunning} handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished} />
                    </div>
                    <Timer  ms={msToAnswer} isReady={true} isRunning={this.state.isRunning} bar={true}  handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished}  />
                </Segment>
        )
    }

}

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    question:state.game?state.game.question:undefined,
})

const mapDispatchToProps = (dispatch, { socket }) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormAnswer)


// WEBPACK FOOTER //
// ./src/components/FormAnswer.js